// Runtime cookie-auth toggle, set once after LaunchDarkly resolves. Defaults to
// false so behavior is identical to today until LD answers (and on LD error).
//
// When enabled, the session lives in an HttpOnly cookie set by the backend at
// login instead of a bearer token in sessionStorage, and every request carries
// the CSRF header (see the cookie-csrf transport in @tastyworks/tastyworks-api).
// Driven by the runtime `web-cookie-auth` LaunchDarkly flag.
let runtimeEnabled = false

export function setCookieAuthEnabled(enabled: boolean): void {
  runtimeEnabled = enabled
}

export function isCookieAuthEnabled(): boolean {
  return runtimeEnabled
}

export function getCookieAuthOverride(): boolean | null {
  if (typeof localStorage === "undefined") {
    return null
  }
  const override = localStorage.getItem("use_cookie_auth")
  if (override === "true") {
    return true
  }
  return override === "false" ? false : null
}

export function isCookieModeRequested(): boolean {
  return (
    new URLSearchParams(window.location.search).get("auth-mode") === "cookie"
  )
}
